var exports = {
  "iU": "Message.module__message___WXhjLT",
  "Ph": "Message.module__messagePreviewSpacing___WXhjLT",
  "IL": "Message.module__messagePreview___WXhjLT",
  "Xo": "Message.module__messageHovered___WXhjLT",
  "uK": "Message.module__focusRingAnchor___WXhjLT",
  "J8": "Message.module__messageCompact___WXhjLT",
  "L8": "Message.module__messageMentioned___WXhjLT",
  "m6": "Message.module__messageReplying___WXhjLT",
  "O6": "Message.module__messageHighlight___WXhjLT",
  "lY": "Message.module__contextMenuActive___WXhjLT",
  "Bc": "Message.module__mobileLayout___WXhjLT",
  "p2": "Message.module__messageLongPress___WXhjLT",
  "Uw": "Message.module__messageGrouped___WXhjLT",
  "kT": "Message.module__messageEditing___WXhjLT",
  "E4": "Message.module__messageSent___WXhjLT",
  "mr": "Message.module__messageSending___WXhjLT",
  "b$": "Message.module__messageFailed___WXhjLT",
  "RZ": "Message.module__failedFooter___WXhjLT",
  "Iu": "Message.module__failedFooterMessage___WXhjLT",
  "bg": "Message.module__failedFooterLabel___WXhjLT",
  "OZ": "Message.module__failedFooterIcon___WXhjLT",
  "dv": "Message.module__failedRetryIcon___WXhjLT",
  "QW": "Message.module__failedRetryButton___WXhjLT",
  "q5": "Message.module__messageGutterLeft___WXhjLT",
  "ZN": "Message.module__messageGutterRight___WXhjLT",
  "$7": "Message.module__messageAvatar___WXhjLT",
  "CW": "Message.module__messageNoText___WXhjLT",
  "U7": "Message.module__messageContent___WXhjLT",
  "rO": "Message.module__messageAuthorInfo___WXhjLT",
  "xW": "Message.module__jumpHeading___WXhjLT",
  "RO": "Message.module__jumpHeadingButton___WXhjLT",
  "dw": "Message.module__messageAuthorRow___WXhjLT",
  "um": "Message.module__messageUsername___WXhjLT",
  "Lo": "Message.module__messageText___WXhjLT",
  "AY": "Message.module__messageAuthorPart___WXhjLT",
  "oL": "Message.module__messageTimestamp___WXhjLT",
  "L5": "Message.module__messageTimestampCompact___WXhjLT",
  "tQ": "Message.module__compactAuthorPrefix___WXhjLT",
  "U6": "Message.module__copyOnly___WXhjLT",
  "Mz": "Message.module__compactInlineContent___WXhjLT",
  "aM": "Message.module__systemMessageContent___WXhjLT",
  "vp": "Message.module__contextMenuUnderline___WXhjLT",
  "aE": "Message.module__messageTimeoutIndicator___WXhjLT",
  "t4": "Message.module__textSeparator___WXhjLT",
  "BK": "Message.module__authorDashSeparator___WXhjLT",
  "KL": "Message.module__messageTimestampHover___WXhjLT",
  "jh": "Message.module__messageTimestampCompactHover___WXhjLT",
  "iZ": "Message.module__messageAvatarCompact___WXhjLT",
  "kq": "Message.module__compactContentWrapper___WXhjLT",
  "xv": "Message.module__hoverAction___WXhjLT",
  "kL": "Message.module__container___WXhjLT",
  "tI": "Message.module__repliedMessage___WXhjLT",
  "_T": "Message.module__repliedMessageCompact___WXhjLT",
  "$y": "Message.module__repliedTextPreview___WXhjLT",
  "NL": "Message.module__repliedAvatar___WXhjLT",
  "a3": "Message.module__repliedIconContainer___WXhjLT",
  "Pq": "Message.module__repliedIcon___WXhjLT",
  "EK": "Message.module__repliedUsername___WXhjLT",
  "IQ": "Message.module__repliedItalic___WXhjLT",
  "Mx": "Message.module__unstyled___WXhjLT",
  "Io": "Message.module__repliedTextContent___WXhjLT",
  "c": "Message.module__systemMessageFollowsSystem___WXhjLT",
  "Hj": "Message.module__systemMessageIconWrapper___WXhjLT",
  "Po": "Message.module__systemMessageIconCompact___WXhjLT",
  "jJ": "Message.module__systemMessageTimestamp___WXhjLT",
  "rc": "Message.module__systemMessageContentWrapper___WXhjLT",
  "V_": "Message.module__systemMessageCompactContent___WXhjLT",
  "Gq": "Message.module__systemMessageIconSvg___WXhjLT",
  "hr": "Message.module__systemMessageLink___WXhjLT",
  "x": "Message.module__userTagOffset___WXhjLT",
  "DX": "Message.module__userVerifiedBadge___WXhjLT",
  "ll": "Message.module__userTagCompact___WXhjLT",
  "O4": "Message.module__editedTimestamp___WXhjLT",
  "k8": "Message.module__editedLabel___WXhjLT",
  "zX": "Message.module__typingContainer___WXhjLT",
  "Y9": "Message.module__typingCluster___WXhjLT",
  "RL": "Message.module__typingIndicator___WXhjLT",
  "Kl": "Message.module__typingAvatarContainer___WXhjLT",
  "tY": "Message.module__typingText___WXhjLT",
  "AZ": "Message.module__typingClusterComposerStatus___WXhjLT",
  "am": "Message.module__compactContentNoPrefix___WXhjLT",
  "Ys": "Message.module__compactBody___WXhjLT",
  "Ac": "Message.module__unknownMessageCompactContent___WXhjLT",
  "qU": "Message.module__unknownMessageWarning___WXhjLT",
  "NG": "Message.module__keyboardFocused___WXhjLT",
  "an": "Message.module__messageClientSystem___WXhjLT",
  "og": "Message.module__systemMessageContainer___WXhjLT",
  "Is": "Message.module__systemMessageIcon___WXhjLT",
  "ry": "Message.module__mediaFocusRing___WXhjLT",
  "xS": "Message.module__systemMessageDismissButton___WXhjLT",
  "Eu": "Message.module__silentMessageIcon___WXhjLT",
};

module.exports = exports;
